import React, { useState, useEffect, Fragment } from "react";
import { doDownloadPdf, doPut } from "../services/api-service";
import { withRouter } from "react-router";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";

import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import Print from "@material-ui/icons/Print";
import KeyboardBackspace from "@material-ui/icons/KeyboardBackspace";
import TextField from "@material-ui/core/TextField";
import Conditional from "../components/Conditional";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const PaDetailAssessmentComponent = props => {
    const [unsurScores, setUnsurScores] = useState([]);
    const [aspekScores, setAspekScores] = useState([]);
    const [subAspekScores, setSubAspekScores] = useState([]);
    const [grandTotal, setgrandTotal] = useState(0);
    const [category, setCategory] = useState("A");
    const [approvalDone, setApprovalDone] = useState(false);
    const [openEdit, setOpenEdit] = useState(false);

    const [countAtasan, setCountAtasan] = useState(1);
    const [colspanBobot, setColspanBobot] = useState(1);
    const [colspanLeader, setColspanLeader] = useState(1);

    const [alreadyLeader1, setAlreadyLeader1] = useState(0);
    const [alreadyLeader2, setAlreadyLeader2] = useState(0);
    const [alreadyLeader3, setAlreadyLeader3] = useState(0);
    const [alreadyStaff, setAlreadyStaff] = useState(0);
    const [isStaff, setIsStaff] = useState(0);
    const [tobeAgree, setTobeAgree] = useState(0)
    const [atasanDisagree, setAtasanDisagree] = useState(0)

    const [atasanIds, setAtasanIds] = useState(0);


    const toggleAlreadyStaff = () =>{
      
        if(props.assessment.fill_by_staff==1){
            setAlreadyStaff(1)
        }else{
            setAlreadyStaff(0)
        }

        if(props.user.emp_id==props.assessment.participant_id){
            setIsStaff(1)
        }else{
            setIsStaff(0)
        }

    }

    const toggleAlreadyLeader = () =>{

        const atasan_ids =  props.assessment.atasan_id.split(',');
        const fill_atasan_ids =  props.assessment.fill_by_nik_atasan.split(',');

        var array_push = [];

        fill_atasan_ids.map(row => {
            let index = atasan_ids.indexOf(row);
            array_push.push(index+1);
        })

        setAtasanIds(atasan_ids)

        array_push.map(obj=>{

            let name = props.assessment.leader_names[obj-1]

            console.log(name)

            if(obj==1){
                setAlreadyLeader1(1)
            }

            if(obj==2){
                setAlreadyLeader2(1)
            }

            if(obj==3){
                setAlreadyLeader3(3)
            }

        })


    }

    const confirmAgree = (agree, atasanId='')=>{
        setTobeAgree(agree)
        setAtasanDisagree(atasanId)
    }
    
    
    useEffect(() => {
        if(props.assessment){

            toggleAlreadyStaff()
            toggleAlreadyLeader()

            const unsurScoreTemp = props.assessment.unsurs.map(unsur=>({...unsur, unsur_id:unsur.id,sub_aspek_id:unsur.sub_aspek_id}))
            const aspekScoreTemp = props.assessment.aspeks.map(aspek=>({...aspek, aspek_id:aspek.id}))
            const subAspekScoreTemp = props.assessment.sub_aspeks.map(subAspek=>({...subAspek, sub_aspek_id:subAspek.id, aspek_id:subAspek.aspek_id}))
           
            console.log("aspekScoreTemp", aspekScoreTemp)
           
            setUnsurScores(unsurScoreTemp)
            setAspekScores(aspekScoreTemp)
            setSubAspekScores(subAspekScoreTemp)
            setgrandTotal(props.assessment.total_score)
            setOpenEdit(!props.assessment.fill_by_staff)

            const atasans =  props.assessment.atasan_id.split(',');
            

            const results = atasans.filter(element => {
                return element !== '';
              });

              const jmlatasan = results.length

            setCountAtasan(jmlatasan)

            if(jmlatasan==1){
                setColspanLeader(3)
                setColspanBobot(3)
            }else if(jmlatasan==2){
                setColspanLeader(1)
                setColspanBobot(2)
            }else if(jmlatasan==3){
                setColspanLeader(1)
                setColspanBobot(3)
            }else{
                setColspanLeader(3)
                setColspanBobot(3)
            }

            // if(props.assessment.total_score > 3.5){
            //     setCategory("A")
            // }else if(props.assessment.total_score > 3){
            //     setCategory("B")
            // }else if(props.assessment.total_score > 2.5){
            //     setCategory("C")
            // }else{
            //     setCategory("D")
            // }

            if(props.assessment.total_score >= 3.70){
                setCategory("A+")
            }else if(props.assessment.total_score >= 3.40){
                setCategory("A")
            }else if(props.assessment.total_score >= 3.10){
                setCategory("A-")
            }else if(props.assessment.total_score >= 2.80){
                setCategory("B+")
            }else if(props.assessment.total_score >= 2.50){
                setCategory("B")
            }else if(props.assessment.total_score >= 2.20){
                setCategory("B-")
            }else if(props.assessment.total_score >= 1.90){
                setCategory("C+")
            }else if(props.assessment.total_score >= 1.60){
                setCategory("C")
            }else{
                setCategory("D")
            }


            
        }
    }, [props.assessment])


    const openingEdit = async () => {
        setOpenEdit(!openEdit)
        const params={
            assessment_user_id:props.assessment.id,
            fill_by_staff : (!openEdit === true) ? 0:1
        }
        await doPut("pa/assessment/edit/staff",params);

    };

    const exportPdf = async () => {
        const params={assessment_user_id:props.assessment.id, filename:props.assessment.participant_name}
        doDownloadPdf("pa/assessment/export/pdf",params);
    };


    const approval = async (number, atasan_id) => {
        setApprovalDone(true)
        const params={
            assessment_user_id:props.assessment.id,
            approval:number,
            atasan_id:atasan_id,

        }
        await doPut("pa/assessment/approval/staff",params);
        props.history.goBack();
    };

    const { classes } = props;

    const CategoryLabel = ({role,unsur}) => {
        let label = ""
        let score = role==="atasan_1" ? unsur.atasan_score : role==="atasan_2" ? unsur.atasan_score_2 : role==="atasan_3" ? unsur.atasan_score_3 : unsur.staff_score

        switch (score){
            case 0 :
                label =  unsur.category_0_label
            break
            case 1 :
                label =  unsur.category_1_label
            break
            case 2 :
                label = unsur.category_2_label
            break
            case 3 :
                label = unsur.category_3_label
            break
            case 4 :
                label = unsur.category_4_label
            break
        }

        // console.log("score", score)

        if(score===null || score==='null' || score=='null' || score==null){
            return <span></span>
        }else{  
            return <span>{label}</span>
        }   
        // return <span>{label}</span>
    }


    const getInitials = (name='') =>{
        const removeFirstWord = (str) => {
            const indexOfSpace = str.indexOf(' ');
            if (indexOfSpace === -1) {
                return '';
            }
            return str.substring(indexOfSpace + 1);
        }

        // name = 'Elisabet Aprilia Reni I'

        let firstName = name.split(' ')[0]
        let lastName = removeFirstWord(name).match(/(\b\S)?/g).join("").match(/(^\S|\S$)?/g).join(" ").toUpperCase();
    
         return firstName+' '+lastName

    }

    const ApprovalButton = ({user, owner, status, action, disabled}) =>{


        if(status === 1){
            return (
                <h2 >approved by staff</h2>
            )
        }

        if(status === 2){
            return (
                <h2 >rejected by staff</h2>
            )
        }

        if(user.toString() !== owner.toString()){
            return null
        }


        return (
            <Grid spacing={8} container justify="flex-end" className={classes.marginTops}>

                

                <Conditional condition={countAtasan>0}>
                    <Grid item xs={2} container justify="flex-end">
                        <Button disabled={disabled} variant="contained" color="secondary"
                           onClick={()=>confirmAgree(2, atasanIds[0])} 
                        // onClick={()=>action(2, atasanIds[0])}
                        >
                            disagree Leader 1
                        </Button>
                    </Grid>
                </Conditional>

                <Conditional condition={countAtasan>1}>
                    <Grid item xs={2} container justify="flex-end">
                        <Button disabled={disabled} variant="contained" color="secondary"
                         onClick={()=>confirmAgree(2, atasanIds[1])}
                        // onClick={()=>action(2, atasanIds[1])}
                        >
                            disagree Leader 2
                        </Button>
                    </Grid>
                </Conditional>
                
                <Conditional condition={countAtasan>2}>
                    <Grid item xs={2} container justify="flex-end">
                        <Button disabled={disabled} variant="contained" color="secondary"
                        //  onClick={()=>action(2, atasanIds[2])}
                        onClick={()=>confirmAgree(2, atasanIds[2])}
                         >
                        disagree Leader 3
                        </Button>
                    </Grid>
                </Conditional>
                <Grid item xs={1}>
                    <Button disabled={disabled} variant="contained" color="primary" 
                    onClick={()=>confirmAgree(1)}
                    // onClick={()=>action(1)}
                    >
                    Agree<br/><br/>
                    </Button>
                </Grid>


                <Dialog
                    open={tobeAgree!==0}
                    onClose={()=>setTobeAgree(0)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Confirmation ?"}</DialogTitle>
                    <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Apakah anda yakin akan memproses data ini ?
                    </DialogContentText>
                    </DialogContent>
                    <DialogActions>                                                        
                    <Button onClick={()=>action(tobeAgree, atasanDisagree)} color="secondary">
                        Process
                    </Button>
                    <Button onClick={()=>setTobeAgree(0)} variant="contained" color="primary">
                        Cancel
                    </Button>
                    </DialogActions>
                </Dialog>

            </Grid>
        )
    }

    if(props.assessment){
        return (
            <React.Fragment>
                <Grid container className={classes.container}>
                    <Grid item xs={12} spacing={8} container>
                        <Grid item xs={1} container alignContent="center">
                            <IconButton color="primary" aria-label="back" component="span" onClick={() => props.history.goBack()}>
                                <KeyboardBackspace />
                            </IconButton>
                        </Grid>
                        <Grid item xs={7} container alignContent="center">
                            <Typography
                                variant="h6"
                                gutterBottom
                                className="animated slideInLeft"
                            >
                                {`Assessment Detail for ${props.assessment.participant_name}` }
                            </Typography>
                        </Grid>
                        <Grid item xs={3} container>
                        {/* {props.assessment.atasan_id === props.user.emp_id && */}
                            {/* {alreadyLeader1} {alreadyLeader2} {alreadyLeader3} {openEdit} */}
                            {/* {(alreadyLeader1 === 1 || alreadyLeader2===1 || alreadyLeader3===1) && isStaff!=1 && */}

                            { isStaff!=1 &&
                                <Button size="small" color="primary" onClick={openingEdit}>
                                    {
                                    openEdit &&  "close editing access for staff" || "open editing access for staff"
                                    }
                                </Button>
                             }
                        </Grid>
                        <Grid item xs={1} container justify="flex-end" alignContent="center">
                                <IconButton onClick={exportPdf} color="primary" aria-label="search">
                                    <Print />
                                </IconButton>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} container direction="column">
                    <Grid container className={classes.table_header}>
                            <Grid item xs={countAtasan > 2 ? 3 : 4} container justify="center">Indicator</Grid>
                            <Grid item xs={1}>weight</Grid>
                            <Conditional condition={countAtasan>0}>
                                <Grid item xs={colspanLeader+1} container justify="center">
                                <Conditional condition={alreadyLeader1==0}>
                                    <Tooltip title="Belum Isi">
                                        <span className={classes.notFilled}>*</span>
                                    </Tooltip>
                                </Conditional>
                                    Leader 1  <br/>
                                
                                    {getInitials(props.assessment.leader_names[0])}

                                    <br/>
                                 {props.assessment.bobot_atasan} %
                                </Grid>
                            </Conditional>
                            <Conditional condition={countAtasan>1}>
                                <Grid item xs={colspanLeader+1} container justify="center">
                                <Conditional condition={alreadyLeader2==0}>
                                    <Tooltip title="Belum Isi">
                                        <span className={classes.notFilled}>*</span>
                                    </Tooltip>
                                </Conditional>
                                Leader 2  <br/>
                                {getInitials(props.assessment.leader_names[1])}
                                <br/> {props.assessment.bobot_atasan} %
                                </Grid>
                            </Conditional>
                            <Conditional condition={countAtasan>2}>
                                <Grid item xs={colspanLeader+1} container justify="center">
                                    <Conditional condition={alreadyLeader3==0}>
                                        <Tooltip title="Belum Isi">
                                            <span className={classes.notFilled}>*</span>
                                        </Tooltip>
                                    </Conditional>
                                    Leader 3 <br/>
                                    {getInitials(props.assessment.leader_names[2])}
                                    <br/> {props.assessment.bobot_atasan} %
                                </Grid>
                                </Conditional>
                            
                           
                            <Grid item xs={1} container justify="center">
                                <Conditional condition={alreadyStaff==0}>
                                    <Tooltip title="Belum Isi">
                                        <span className={classes.notFilled}>*</span>
                                    </Tooltip>
                                </Conditional>Staff <br/> {props.assessment.bobot_bawahan} %</Grid>
                            <Grid item xs={countAtasan > 2 ? 1 : 2} container justify="flex-end">Total</Grid>
                        </Grid>
{/* 
                        <Grid container className={classes.table_header}>
                            <Grid item xs={countAtasan > 2 ? 4 : 6} container justify="center"></Grid>
                            <Grid item xs={colspanBobot+1} container justify="center">{props.assessment.bobot_atasan} %  </Grid>
                            <Grid item xs={2} container justify="center">{props.assessment.bobot_bawahan} % </Grid>
                        </Grid> */}

                        {/* {props.assessment.bobot_bawahan} % */}
    
                        <Grid container >
                                {aspekScores.map(aspek => (
                                    <Grid container className={classes.aspek_container}>
                                        <Grid container className={classes.aspek_row}>
                                            <Grid item xs={1}>{aspek.code}</Grid>
                                            <Grid item xs={5}>{aspek.name}</Grid>
                                            <Grid item xs={6} className={classes.aspek_score}>
                                                {
                                                    aspek.score.toFixed(2)
                                                }
                                            </Grid>
                                        </Grid>
                                        {subAspekScores
                                            .filter(a => a.aspek_id === aspek.id)
                                            .map(sub_aspek => (
                                                <Grid container className={classes.sub_aspek}>
                                                    <Grid container className={classes.sub_aspek_row}>
                                                        <Grid item xs={1}>{sub_aspek.code}</Grid>
                                                        <Grid item xs={5}>{sub_aspek.name}</Grid>
                                                        <Grid item xs={6} className={classes.sub_aspek_score}>
                                                        {
                                                            sub_aspek.score.toFixed(2)
                                                        }
                                                        </Grid>
                                                    </Grid>
                                                    {unsurScores
                                                        .filter(u =>u.sub_aspek_id === sub_aspek.id)
                                                        .sort((a, b) => {
                                                            // Menggunakan perbandingan kode untuk mengurutkan secara ASC
                                                            return a.code.localeCompare(b.code);
                                                        })
                                                        .map(unsur => (
                                                            <Grid container className={classes.unsur}>
                                                                <Grid container className={classes.unsur_row}>
                                                                    <Grid item xs={1}>{unsur.code}</Grid>
                                                                    <Grid item xs={countAtasan > 2 ? 3 : 3}>

                                                                    {unsur.name.split('\n').map((item, key) => {
                                                                        return <Fragment key={key}>{item}<br/></Fragment>
                                                                    })}
                                                                        {/* {unsur.name} */}
                                                                    </Grid>
                                                                    <Grid item xs={1}>{unsur.bobot}%</Grid>
                                                                    

                                                                    <Conditional condition={countAtasan>0}>
                                                                        <Grid item xs={colspanLeader+1} 
                                                                            container={countAtasan==3 || countAtasan==2  ? false : true} 
                                                                            justify={countAtasan==3 || countAtasan==2 ? 'left' : 'left'}>
                                                                            {unsur.atasan_score}&nbsp;
                                                                                <CategoryLabel role="atasan_1" unsur={unsur}/>
                                                                        </Grid>
                                                                    </Conditional>
                                                                    <Conditional condition={countAtasan>1}>
                                                                        <Grid item xs={colspanLeader+1} 
                                                                        container={countAtasan==3 || countAtasan==2  ? false : true} 
                                                                        justify={countAtasan==3 || countAtasan==2 ? 'left' : 'left'}>
                                                                        {unsur.atasan_score_2}&nbsp;
                                                                            <CategoryLabel role="atasan_2" unsur={unsur}/>
                                                                        </Grid>
                                                                    </Conditional>
                                                                    <Conditional condition={countAtasan>2}>
                                                                        <Grid item xs={colspanLeader+1} 
                                                                        container={countAtasan==3 || countAtasan==2 ? false : true} 
                                                                        justify={countAtasan==3 || countAtasan==2 ? 'left' : 'left'}>
                                                                        {unsur.atasan_score_3}&nbsp;
                                                                            <CategoryLabel role="atasan_3" unsur={unsur}/>
                                                                        </Grid>
                                                                    </Conditional>
                                                                    <Grid item xs={countAtasan > 2 ? 1 : 2}>{unsur.staff_score}&nbsp;<CategoryLabel role="staff" unsur={unsur}/></Grid>
                                                                    
                                                                    {/* <Grid item container xs={5} justify="space-evenly" alignItems="center">

    

                                                                        <Conditional condition={countAtasan>0}>

                                                                            <Grid item xs={1} container justify="flex-center">

                                                                                <Grid item>
                                                                                    {
                                                                                        unsur.atasan_score
                                                                                    }
                                                                                    <br />Sangat Baik
                                                                                    
                                                                                </Grid>

                                                                            </Grid>
                                                                        </Conditional>
                                                                        
                                                                        <Conditional condition={countAtasan>1}>
                                                                            <Grid item xs={1} container spacing={8} justify="flex-center" alignItems="center" className={countAtasan==3 ? classes.unsur_score_2_mode_3 : classes.unsur_score_2_mode_1} >

                                                                                <Grid item>
                                                                                    {
                                                                                        unsur.atasan_score_2
                                                                                    }
                                                                                    &nbsp; <CategoryLabel role="atasan" unsur={unsur}/>
                                                                                </Grid>

                                                                            </Grid>
                                                                        </Conditional>

                                                                        <Conditional condition={countAtasan>2}>
                                                                            <Grid item xs={1} container spacing={8} justify="flex-center" alignItems="center" className={countAtasan==3 ? classes.unsur_score_3_mode_3 : classes.unsur_score_3_mode_1} >

                                                                                <Grid item>
                                                                                    {
                                                                                        unsur.atasan_score_3
                                                                                    }

                                                                                    &nbsp;<CategoryLabel role="atasan" unsur={unsur}/>
                                                                                </Grid>

    
                                                                            </Grid>
                                                                        </Conditional>


                                                                        <Grid item xs={2} container spacing={8} justify="flex-center" alignItems="center" className={countAtasan==3 ? classes.unsur_score_staff_mode_3 : classes.unsur_score_staff_mode_1} >

                                                                            <Grid item>
                                                                                {
                                                                                    unsur.staff_score
                                                                                }
                                                                                <br/><CategoryLabel role="staff" unsur={unsur}/>
                                                                            </Grid>
                       
                                                                        </Grid>

                                                                        


                                                                    </Grid> */}
                                                                </Grid>
                                                            </Grid>
                                                        ))}
                                                </Grid>
                                            ))}
                                    </Grid>
                                ))}
                        </Grid>

                        <Grid container justify="space-between" className={classes.grand_total}>
                            <Grid item xs={2}> Grand Total</Grid>
                            <Grid item xs={1} container justify="flex-end"> {grandTotal.toFixed(2)}</Grid>
                        </Grid>
                        <Grid container justify="space-between" className={classes.grand_total}>
                            <Grid item xs={2}> Kategori</Grid>
                            <Grid item xs={1} container justify="flex-end"> {category}</Grid>
                        </Grid>

                        <Grid container className={classes.note_container}>
                            <TextField
                            id="outlined-multiline-static"
                            label="Notes from leader"
                            multiline
                            rows="2"
                            defaultValue="Notes from leader"
                            variant="outlined"
                            fullWidth
                            value={props.assessment.note_atasan}
                            />
                        </Grid>

                        {props.assessment.fill_by_atasan===1 &&
                        <>
                            <ApprovalButton
                            user={props.user.emp_id}
                            owner={props.assessment.participant_id}
                            status={props.assessment.approval_staff}
                            disabled={approvalDone}
                            action={approval}/>

</>
                        }


                    </Grid>
                </Grid>
            </React.Fragment>

        );
    }else{
        return null
    }

};

const styles = theme => ({
    container: {
        marginTop: -16,
        marginLeft: 5
    },
    marginTops: {
        marginTop: 10
    },
    sub_aspek: {
        paddingLeft: 10
    },
    unsur: {
        paddingLeft: 10
    },
    aspek_container:{
        border: "1px solid #c4c4c4",
        borderRadius:4,
        margin:"5px 0 5px 0"
    },
    aspek_row:{
        padding:5,
        backgroundColor:"#d2fce4",
        borderBottom: "1px solid #c4c4c4",
        color:"red",
        fontWeight: "bold",
    },
    aspek_score:{
        display:"flex",
        justifyContent:"flex-end",
        fontWeight: "bold",
        fontSize:17,
        color:"red"
    },
    sub_aspek_row:{
        padding:5,
        backgroundColor:"#7fcbfb",
        borderLeft: "1px solid #c4c4c4",
        borderBottom: "1px solid #c4c4c4",

    },
    sub_aspek_score:{
        display:"flex",
        justifyContent:"flex-end",
        fontWeight: "bold",
        fontSize:13,
        color:"#000000"
    },
    unsur_row:{
        padding:5,
        borderLeft: "1px solid #c4c4c4",
        borderBottom: "1px solid #c4c4c4",

    },

    notFilled:{
        color:"#FF0000"
    },

    labelScore:{
        fontSize:12
    },

    grand_total:{
        backgroundColor:"#fdfbbd",
        color:"#be0609",
        fontWeight: "bold",
        padding:"5px 10px 5px 10px",
        border: "1px solid #c4c4c4",
        borderRadius:4,
        margin:"5px 0 5px 0"
    },
    table_header:{
        backgroundColor:"#ffdb76",
        padding :5,

    },
    centeredCell:{
        display:"flex",
        alignContent:"center"
    },
    note_container:{
        marginTop:20
    }



});

const mapStateToProps = state => {
    return {
        user: state.user.user,
        assessment: state.assessment.assessment_detail
    };
};

const PaDetailAssessment = connect(mapStateToProps)(PaDetailAssessmentComponent);

export default withRouter(withStyles(styles)(PaDetailAssessment));
